import React from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Icon } from '@uhg-abyss/web/ui/Icon';
import { ValidationError } from '../types';

interface ErrorListProps {
  errors: ValidationError[];
}

export const ErrorList: React.FC<ErrorListProps> = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return (
      <Card>
        <Text fontWeight="bold" color="green">No Errors</Text>
        <Text>All records validated successfully — file is ready.</Text>
      </Card>
    );
  }

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      {errors.map((err, idx) => (
        <Card key={idx}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Text fontWeight="medium">Line {err.line}: {err.field}: {err.message}</Text>
            </div>
            <Icon icon={err.severity === 'error' ? 'error' : 'warning'} />
          </div>
          <div style={{ marginTop: 8 }}>
            <Text color="#666">Expected: {err.expected || 'N/A'} — Actual: {err.actual || '(empty)'} — Fix: {err.fixSuggestion || 'Review spec'}</Text>
          </div>
        </Card>
      ))}
    </div>
  );
};
